module.exports = __webpack_public_path__ + "static/media/Apollo_WORD_WHITE.fc5f6368.svg";